import requestor from "shared/service/requestor";
import { SERVICE_PROJECT_ID } from "shared/service/consts.js";

export default class MultimediaApi {
  file = {
    upload: (file) => {
      const formData = new FormData();
      formData.append("file", file);

      return requestor.post("/multimedia/upload_file", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
  };

  image = {
    upload: (
      image,
      {
        modelId = null,
        modelTypeId = null,
        modelPropertyName = null,
        positionX = null,
        positionY = null,
        cropWidth = null,
        cropHeight = null,
        previewWidth = null,
        previewHeight = null,

        isAdmin = false,
        isEditor = false,
        isInput = false,
      } = {}
    ) => {
      let endPointUrl;

      const formData = new FormData();

      formData.append("image", image);

      modelId && formData.append("model_id", modelId);
      modelTypeId && formData.append("model_type_id", modelTypeId);
      modelPropertyName && formData.append("model_property_name", modelPropertyName);
      positionX && formData.append("position_x", positionX.toFixed(2));
      positionY && formData.append("position_y", positionY.toFixed(2));
      cropWidth && formData.append("crop_width", cropWidth.toFixed(2));
      cropHeight && formData.append("crop_height", cropHeight.toFixed(2));
      previewWidth && formData.append("preview_width", previewWidth.toFixed(2));
      previewHeight && formData.append("preview_height", previewHeight.toFixed(2));

      let headers = {
        "Content-Type": "multipart/form-data",
      };

      if (isAdmin) {
        headers["ProjectId"] = SERVICE_PROJECT_ID;
        if (isInput) {
          endPointUrl = "/manage/upload-image-input";
        } else if (isEditor) {
          endPointUrl = "/manage/upload-image-editor";
        }
      } else {
        if (isInput) {
          endPointUrl = "/multimedia/upload-image-input";
        } else if (isEditor) {
          endPointUrl = "/multimedia/upload-image-editor";
        }
      }

      return requestor.post(endPointUrl, formData, {
        headers: headers,
      });
    },
    delete: (imageId, modelId, modelTypeId, modelPropertyName) =>
      requestor.delete("/multimedia/delete-image", {
        image_id: imageId,
        model_id: modelId,
        model_type_id: modelTypeId,
        model_property_name: modelPropertyName,
      }),
  };

  video = {
    saveVimeoVideo: (vimeoVideoId, name) =>
      requestor.post("/multimedia/video_save_vimeo_video", { vimeo_video_id: vimeoVideoId, name: name }),
    initiateVideoUpload: (name, sizeInBytes) =>
      requestor.post("/multimedia/video_initiate_upload", { name: name, size_in_bytes: sizeInBytes }),
    initiateVideoPull: (link) => requestor.post("/multimedia/video_initiate_pull", { link: link }),
    initiateVideoAddIframe: (link) => requestor.post("/multimedia/video_initiate_add_iframe", { link: link }),
    setVimeoPreview: (video_id, frame_time) =>
      requestor.patch("/multimedia/video_set_vimeo_preview", { video_id, frame_time }),
    uploadVimeoPreview: (video_id, preview) => {
      const formData = new FormData();
      formData.append("preview", preview);
      formData.append("video_id", video_id);

      return requestor.post("/multimedia/video_upload_vimeo_preview", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    getList: (page = 1, search = "") =>
      requestor.get("/multimedia/video_list", {
        page: page,
        filter: { search: search },
      }),
  };
}
